import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    component: () => import('../views/Layout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue')
      },
      {
        path: 'agents',
        name: 'Agents',
        component: () => import('../views/Agents.vue')
      },
      {
        path: 'doctors',
        name: 'Doctors',
        component: () => import('../views/Doctors.vue')
      },
      {
        path: 'patients',
        name: 'Patients',
        component: () => import('../views/Patients.vue')
      },
      {
        path: 'orders',
        name: 'Orders',
        component: () => import('../views/Orders.vue')
      },
      {
        path: 'profits',
        name: 'Profits',
        component: () => import('../views/Profits.vue')
      },
      {
        path: 'withdrawals',
        name: 'Withdrawals',
        component: () => import('../views/Withdrawals.vue')
      },
      {
        path: 'assessments',
        name: 'Assessments',
        component: () => import('../views/Assessments.vue')
      },
      {
        path: 'config',
        name: 'Config',
        component: () => import('../views/Config.vue')
      },
      {
        path: 'roles',
        name: 'Roles',
        component: () => import('../views/Roles.vue')
      },
      {
        path: 'admins',
        name: 'Admins',
        component: () => import('../views/Admins.vue')
      },
      {
        path: 'logs',
        name: 'Logs',
        component: () => import('../views/Logs.vue')
      },
      {
        path: 'materials',
        name: 'Materials',
        component: () => import('../views/Materials.vue')
      },
      {
        path: 'growth-assessments',
        name: 'GrowthAssessments',
        component: () => import('../views/GrowthAssessments.vue')
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('adminToken');
  if (!token && to.path !== '/login') {
    next('/login');
  } else {
    next();
  }
});

export default router;
